import React from "react";
import Layout from "./Layout";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { formatDate } from "../../../_helper/utils/utils";

const ComplianceTracker = () => {
  const { data: complianceData, isLoading } = useItemsFilter(
    ApiEndPoint.PHARMACY,
    "?action=getComplianceTracking"
  );

  return (
    <Layout>
      <div className="p-6 bg-white rounded-lg shadow-md">
        <p className="text-gray-600 mb-6">
          Track compliance for different schedules and monitor if prescriptions
          are needed.
        </p>

        {/* Loader */}
        {isLoading ? (
          <div className="flex justify-center py-10">
            <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full"></div>
          </div>
        ) : complianceData?.length === 0 ? (
          /* Empty State */
          <div className="text-center py-10 text-gray-500">
            <p className="text-lg">No compliance data available.</p>
          </div>
        ) : (
          /* Table */
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border rounded-lg shadow-md">
              <thead className="bg-blue-600 text-white text-left">
                <tr>
                  <th className="px-6 py-3 font-medium text-sm uppercase tracking-wider">
                    #
                  </th>
                  <th className="px-6 py-3 font-medium text-sm uppercase tracking-wider">
                    Schedule
                  </th>
                  <th className="px-6 py-3 font-medium text-sm uppercase tracking-wider">
                    Prescription Needed
                  </th>
                  <th className="px-6 py-3 font-medium text-sm uppercase tracking-wider">
                    Last Updated
                  </th>
                </tr>
              </thead>
              <tbody>
                {complianceData?.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`${
                      index % 2 === 0 ? "bg-gray-50" : "bg-white"
                    } hover:bg-blue-50 transition-all`}
                  >
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {index + 1}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {item.schedule}
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`px-3 py-1 text-sm font-semibold text-white rounded-full ${
                          item.is_prescription_needed
                            ? "bg-green-500"
                            : "bg-gray-500"
                        }`}
                      >
                        {item.is_prescription_needed ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {formatDate(item.date_updated)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ComplianceTracker;
